import isNil from 'lodash/isNil';

export default {
  data() {
    return {
      errorMessage: '',
      isValid: true,
      rules: {
        required: (value) => !(isNil(value) || value.length === 0) || this.$t('misc.required'),
      },
    };
  },
};
